<template>
  <div class="Ico">
    <div>
      <span :style="{backgroundImage: `url(${item.url})`}"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item']

}
</script>

<style>
.Ico {
  display: inline-flex;
  align-items: flex-end;
  justify-content: center;
}
.Ico > div{
  width: fit-content;
  flex: 1 0 0;
  margin-top: 20%;
}
.Ico span {
    display: inline-block;
    margin: auto;
    overflow: hidden;
    background: no-repeat center;
    background-size: contain;
    width: 1em;
    height: 1em;
    vertical-align: baseline;
}

</style>
